module.exports = __webpack_public_path__ + "img/bed.a60527a6.svg";